import axios from '@/apis/axios';
import { transformObjectValuesToUpperCase } from '@/transformer/transform';

class Company
{
    // static async all()
    // {
    //     return axios.get('/api/companies');
    // }

    static async all()
    {
        const response = await axios.get('/api/companies/all');

        return response.data;
    }

    static async getIncorporatedCompanies()
    {
        return axios.get('/api/incorporated-companies');
    }

    static async getIncorporatedStatusCompanies()
    {
        const response = await axios.get('/api/company/status/incorporated');

        return response.data.data;
    }


    static async getStatus()
    {
        const response = await axios.get('/api/company/status');

        return response.data.data;
    }

    static async getSupportedShareTypes()
    {
        const response = await axios.get('/api/company/share-types');
        return response.data.data;
    }

    static async getAllShareTypes()
    {
        const response = await axios.get('/api/company/all-share-types');
        return response.data.data;
    }

    static async getSupportedCurrencies(shareTypeId)
    {
        const response = await axios.get(`/api/company/share-types/${shareTypeId}/currencies`);
        return response.data.data;
    }

    static async getAllSupportedCurrencies()
    {
        const response = await axios.get(`/api/company/currencies`);
        return response.data.data;
    }

    static async getDefaultShareCapital()
    {
        const response = await axios.get('/api/company/default-share-capital');
        return response.data.data;
    }

    static async switchCompany(companyId = null)
    {
        const response = await axios.post(`/api/switch-company`, {
            companyId
        });

        return response.data.data;
    }

    static async migrate(data)
    {
        const response = await axios.post('/api/admin/company/migrate', data);
        return response.data;
    }

    static async getMigrationStatus(companyFolderId)
    {
        const response = await axios.post("/api/admin/company/migrating-company-status ", companyFolderId);
        return response.data.data;
    }

    static async update(companyId, data)
    {
        const response = await axios.put(`/api/admin/companies/${companyId}`, transformObjectValuesToUpperCase(data));
        return response.data;
    }

    static async delete(companyId)
    {
        const response = await axios.delete(`/api/admin/companies/${companyId}`);
        return response;
    }

    static async getCurrentCompany()
    {
        const response = await axios.get('/api/current-company');

        return response.data.data;
    }

    static async setOnboardingState()
    {
        const response = await axios.post('/api/is-onboarding');

        return response.data.data;
    }

    static async getFutureDirectorList()
    {
        const response = await axios.get('/api/company/future-director-list');

        return response.data.data;
    }

    static async getSecondaryBusinessActivity()
    {
        const response = await axios.get('/api/company/secondary-business-activity');

        return response.data.data;
    }

    static async getPrimaryBusinessActivity()
    {
        const response = await axios.get('/api/company/primary-business-activity');

        return response.data.data;
    }

    static async getBusinessActivities()
    {
        const response = await axios.get('/api/company/business-activities');

        return response.data.data;
    }
}

export default Company;
